/* @ngInject */
const myCommandeCreateForm = (
  toaster,
  $$commande
) => {
  return {
    restrict: 'E',
    scope: {
      myCommande: '=',
      mySearchedWagons: '=mySearchedWagons',
      enableTitle: '=?',
    },
    template: require('./myCommandeCreateForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.wagonIds = []

      $scope.saveCommande = async (_commande, wagonIds) => {
        try {
          const commande = $$commande.format.server(_commande)
          const response = await $$commande.request.save(commande, wagonIds)
          toaster.message(response.message)
          $scope.reinit()
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.reinit = () => {
        $scope.myCommande = $$commande.new()
        $scope.mySearchedWagons = []
        $scope.createCommandeForm.$setPristine()
        $scope.createCommandeForm.$setUntouched()
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCommandeCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/directives/forms/myCommandeCreateForm.js